<template>
  <section class="visitors">
    <template v-if="!gettingData">
      <template v-if="selectedUser">
        <div class="row mt-10 d-flex align-items-center">
          <div  class="col-md-6">
            <button @click="refreshData()" class="btn btn-sm btn-round btn-outline-default pt-7 pb-7 pl-10 pr-10 btn-default">
              <i class="fa fa-arrow-left fs-20"></i>
            </button>
          </div>
          <div class="col-md-6 d-flex align-items-center justify-content-end">
            <div v-if="hideTemplates" class="dropdown mr-5">
              <button @mouseover="getTitle(true, 'dropdownMenuButton', 'Edit Templates' )" @mouseleave="getTitle(false)" class="btn btn-primary btn-outline-primary dropdown-toggle btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-pencil"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a v-for="(row, index) in emailTemplates" @click="selectedTemplate = index + 1; updatedHtml=emailTemplates[index]" class="dropdown-item" href="#">Template {{index + 1}}</a>
              </div>
            </div>
            <button v-if="!hideTemplates" :disabled="emailTemplateLoading" @click="viewEmailTemplates" class="btn btn-sm btn-danger">
              <span v-if="emailTemplateLoading">Loading <i class="fa fa-spinner fa-spin"></i></span>
              <span v-else>Show Email Templates</span>
            </button>
            <button v-else @click="hideTemplates = false" class="btn btn-sm btn-default btn-outline-default">Hide Email Templates</button>
          </div>
        </div>
        <div v-if="hideTemplates" class="row">
          <template v-if="selectedTemplate && selectedTemplate >= 1">
            <div class="col-md-6">
              <h6 class="text-center">Edit Text</h6>
              <div class="editable"
                   contenteditable="true"
                   @input="updateHtml"
                   v-html="emailTemplates[selectedTemplate - 1]"></div>
            </div>
            <div class="preview col-md-6">
              <h6 class="text-center">Live Preview</h6>
              <div v-html="updatedHtml"></div>
            </div>
            <div class="col-md-12 d-flex justify-content-end">
              <button @click="saveTemplate" class="btn btn-sm btn-primary">Save</button>
            </div>

          </template>

          <div v-else v-for="(row, index) in emailTemplates" :key="index" class="col-md-12">
            <span v-html="row"/>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-12">
            <div style="border: 1px solid #d3d3d394" class="card">
              <div class="card-body">
                <traffic-alert-steps :updatedHtml="updatedHtml" :selected-data="selectedUser" :over-traffic-alert-steps="overTrafficAlertSteps"/>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div style="border: 1px solid #d3d3d394" class="card">
              <div class="card-body">
                <h6 class="text-center fw-600">History Logs</h6>
                <div class="log-box">
                  <div
                      v-for="(log, index) in modifiedLogs"
                      :key="index"
                      class="log-entry"
                      :class="'log-color-' + (index % 5)"
                  >
                    <span class="timestamp">[{{ formatDate(log.date) }} EST] </span>
                    <span v-if="log.log.includes('JSON')">
                    <span class="font-semibold text-blue-600 mb-0">{{log.log.split('JSON:')[0]}}</span>
                    <pre class="mb-0">
                      {{ formattedBashResponse(log.log) }}
                    </pre>
                  </span>
                    <span v-else>{{log.log}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    <div v-show="!selectedUser" class="row">
      <div class="col-md-12 d-flex align-items-center justify-content-end">
        <button :disabled="!modifiedTraffic || !modifiedTraffic.length" @click="exportToCsv" class="btn btn-sm btn-success mr-2">
          <i class="fa fa-download mr-1"></i> Export CSV
        </button>
        <button disabled @click="syncTrafficData" class="btn btn-sm btn-primary pull-right">Sync Traffic Data</button>
        <i data-toggle="tooltip" data-placement="top" title="Manual sync is currently disabled. WPO syncs the traffic data daily between 5:00 AM and 6:00 AM EST." style="font-size: 17px" class="fa fa-info-circle text-danger pull-right"></i>
      </div>
      <div v-if="last_updated" class="col-md-12">
        <small class="pull-right"><b>Last Updated:</b> {{last_updated}}</small>
      </div>
      <div class="col-md-12">
        <table class="table table-bordered " id="visitors-table">
          <thead class="light">
          <tr>
            <!--            <th>Name</th>-->
            <!--            <th>Email</th>-->
            <th>Service</th>
            <th>Traffic Limit</th>
            <th>60 - 90 Days</th>
            <th>30 - 60 Days</th>
            <th>0 - 30 Days</th>
            <th>0 - 30 %</th>
<!--            <th>Ticket</th>-->
            <th>Progress</th>
            <th class="text-center">Snooze</th>
            <th class="text-center">Action <i class="fa fa-bolt"></i></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, index) in modifiedTraffic" :key="index">
            <!--            <td>{{row.name || ''}}</td>-->
            <!--            <td class="text-center">{{ row.email || '' }}</td>-->
            <td class="text-center"><a :href="`https://portal.bigscoots.com/admin/?cmd=accounts&action=edit&id=${row.hbServiceId}`" target="_blank">{{row.planName}} - {{row.primaryDomain}}</a> <span v-if="row.status === 'snoozed'" class="badge badge-pill badge-warning ml-10">Snoozed</span></td>
            <td class="text-center">{{row.totalVisitors ? formatNumber(row.totalVisitors) : 0}}</td>
            <td class="text-center text-danger" :class="{'text-danger': row.percentage > 100}">{{row.secondLastMonth.visitors ? formatNumber(row.secondLastMonth.visitors) : 0}}</td>
            <td class="text-center text-danger" :class="{'text-danger': row.percentage > 100}">{{row.lastMonth.visitors ? formatNumber(row.lastMonth.visitors) : 0}}</td>
            <td class="text-center text-danger" :class="{'text-danger': row.percentage > 100}">{{row.billable ? formatNumber(row.billable) : 0}}</td>
            <td class="text-center text-danger" :class="{'text-danger': row.percentage > 100}">{{ ((Math.abs(row.billable - row.totalVisitors)/row.totalVisitors)*100).toFixed(2)}}%</td>
<!--            <td>-->
<!--              <span class="text-primary" title="Add Tickets" @click="openModal(row, 'ticket')"> <i class=" fa fa-pencil cursor-pointer"></i></span>-->
<!--              <span class="text-primary" title="View ticket" v-if="row.ticket" @click="openTicket(row)"> <i class=" fa fa-eye cursor-pointer ml-2"></i></span>-->
<!--            </td>-->
            <td>
              {{getProgress(row)}}
            </td>
            <td>
              <select style="height: 31px" v-model="row.snoozeVal" class="form-control" @change="selectSnoozeValue(row, $event)">
                <option value="">Select</option>
                <option value="1 day">1 day</option>
                <option value="1 week">1 week</option>
                <option value="1 month">1 month</option>
                <option value="3 months">3 month</option>
                <option value="forever">Forever</option>
                <option value="reset">Reset</option>
              </select>
            </td>
            <td width="10%">
              <button data-toggle="tooltip" data-placement="top" title="Check Steps & History" class="btn btn-info btn-sm ml-2" @click="viewDetails(row)">
                <i class="fa fa-gear"></i>
              </button>
              <button title="Login as user" data-toggle="tooltip" data-placement="top" class="btn btn-primary btn-sm ml-2" @click="loginAsUser(row)">
                <i class="fa fa-user"></i>
              </button>
              <button title="Remove from DB" data-toggle="tooltip" data-placement="top"
                      :disabled="removingId === row.id"
                      class="btn btn-danger btn-sm ml-2" @click="removeFromDb(row)">
                <i v-if="removingId === row.id" class="fa fa-spin fa-spinner"></i>
                <i v-else class="fa fa-trash"></i>
              </button>
<!--              <button @click="openModal(row)" class="btn btn-sm btn-success ml-2">-->
<!--                <i title="Send Email" class="fa fa-envelope"></i>-->
<!--              </button>-->
              <!--              <button title="Resolve" @click="resolve(group.max)" class="btn btn-success btn-sm ml-2">-->
              <!--                <i class=" fa fa-check cursor-pointer"></i>-->
              <!--              </button>-->
              <!--              <button title="Create Ticket" @click="openTicketModal(group.max)" class="btn btn-primary btn-sm ml-2">-->
              <!--                <i class=" fa fa-envelope cursor-pointer"></i>-->
              <!--              </button>-->
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    </template>
    <section v-else>
      <div class="loader"></div>
    </section>

    <div class="modal" tabindex="-1" role="dialog" id="addTicketModal" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">ADD TICKET</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Ticket</label>
              <textarea class="form-control" v-model="selectedRow.ticket"></textarea>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
            <button class="btn btn-outline-info btn-sm" :disabled="loading"  @click="addTicket()">
              <div class="loader mini_loader" v-if="loading"></div>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <traffic-modal ref="trafficTicketModal"/>
  </section>

</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import TrafficAlertSteps from "@/components/Admin/Tasks/trafficAlertSteps.vue";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';

export default {
  name: "Traffic",
  components: {
    TrafficAlertSteps,
    Paginate,
    trafficModal: () => import(/* webpackChunkName: "userList" */ "../../../components/Admin/Tasks/trafficTicketModal")
  },
  props: {
    tableId: {
      type: String
    }
  },
  data() {
    return {
      logs: [
        { timestamp: '12:00:01', message: 'App initialized' },
        { timestamp: '12:00:05', message: 'Fetching user data' },
        { timestamp: '12:00:10', message: 'User authenticated' },
        { timestamp: '12:00:15', message: 'Loading dashboard' },
        { timestamp: '12:00:20', message: 'Dashboard ready' },
        { timestamp: '12:00:25', message: 'New message received' },
        { timestamp: '12:00:30', message: 'Data sync started' },
        { timestamp: '12:00:35', message: 'Sync complete' },
        { timestamp: '12:00:40', message: 'User clicked "Export"' },
        { timestamp: '12:00:45', message: 'Exporting file...' },
      ],
      emailTemplates: [],
      hideTemplates: false,
      updatedHtml: '',
      selectedTemplate: null,
      currentStep: 0,
      email: { sendTo: 'test'},
      traffic: [],
      loading: false,
      gettingData: false,
      listener: false,
      selectedRow: {},
      presetMacros: [],
      overTrafficAlertSteps: [],
      originalSteps: [],
      pageNumber: 0,
      search: '',
      searchQuery: 'over-limit',
      pageSize: 10,
      searchByFilter: [
        { name: 'All', value: 'all'},
        // { name: 'WPO Nodes', value: 'wpo'},
        { name: 'Over Limit', value: 'over-limit'},
      ],
      last_updated: '',
      emailTemplateLoading: false,
      syncLoading: false,
      removingId: null,
      monthArray: [{key: 1, value: 'Jan'},
        {key: 2, value: 'Feb'},
        {key: 3, value: 'Mar'},
        {key: 4, value: 'Apr'},
        {key: 5, value: 'May'},
        {key: 6, value: 'Jun'},
        {key: 7, value: 'Jul'},
        {key: 8, value: 'Aug'},
        {key: 9, value: 'Sep'},
        {key: 10, value: 'Oct'},
        {key: 11, value: 'Nov'},
        {key: 12, value: 'Dec'},
      ],
      selectedUser: null
    }
  },
  async mounted(){
    this.gettingData = true;
    await this.getTrafficData()
    await this.renderDatatable()
    this.gettingData = false;
    // this.renderDatatable()
    await this.getPresetReplies()
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
    // this.initDataTable()
  },
  beforeDestroy(){
    if(this.listener) {
      this.listener()
    }
  },
  watch: {
    traffic() {
      this.renderDatatable()
    }
  },
  computed: {
    modifiedTraffic() {
      return this.traffic.sort((a, b) => a.status - b.status)
    },
    modifiedLogs() {
      const logs = this.selectedUser && this.selectedUser.logs ? JSON.parse(JSON.stringify(this.selectedUser.logs)) : []
      return logs.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    },
    pageCount(){
      let l = this.filteredData.length, s = this.pageSize;
      return Math.ceil(l/s);
    },
    filteredData () {
      const traffic = this.traffic.filter(t => t.name.toLowerCase().includes(this.search.toLowerCase()) || t.email.toLowerCase().includes(this.search.toLowerCase()))
      let array = []
      console.log('asd', traffic.length)
      if(this.searchQuery) {
        if (this.searchQuery === 'all') {
          array = traffic;
        } else if (this.searchQuery === 'over-limit') {
          array = traffic.filter(el => Number(el.percentage) - 100 > 100)
        }
      }
      console.log('asd222', array.length)
      // this.renderDatatable()
      return array
    },
    paginatedTraffic () {
      const start = this.pageNumber * this.pageSize, end = start + this.pageSize;
      return this.filteredData.slice(start, end);
    }
  },
  methods: {
    csvEscape(value) {
      if (value === null || value === undefined) return '';
      const str = String(value);
      if (/[",\n\r]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    },
    exportToCsv() {
      const rows = this.modifiedTraffic || [];
      if (!rows.length) return;
      const headers = [
        'Service', 'Plan', 'Domain', 'Traffic Limit',
        '60-90 Days', '30-60 Days', '0-30 Days', '0-30 %',
        'Email', 'Name'
      ];
      const csvRows = rows.map(row => {
        const limit = Number(row.totalVisitors) || 0;
        const billable = Number(row.billable) || 0;
        const percent = limit > 0
            ? ((Math.abs(billable - limit) / limit) * 100).toFixed(2) + '%'
            : '0%';
        return [
          `${row.planName || ''} - ${row.primaryDomain || ''}`,
          row.planName || '',
          row.primaryDomain || '',
          row.totalVisitors || 0,
          (row.secondLastMonth && row.secondLastMonth.visitors) || 0,
          (row.lastMonth && row.lastMonth.visitors) || 0,
          row.billable || 0,
          percent,
          row.email || '',
          row.name || ''
        ].map(v => this.csvEscape(v)).join(',');
      });
      const csv = [headers.map(h => this.csvEscape(h)).join(','), ...csvRows].join('\r\n');
      const blob = new Blob(['\ufeff' + csv], {type: 'text/csv;charset=utf-8;'});
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const timestamp = moment().format('YYYYMMDD_HHmmss');
      link.setAttribute('href', url);
      link.setAttribute('download', `new_traffic_${timestamp}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    getTitle(flag, id, title) {
      if(!flag) {
        return true
      }
      tippy(`#${id}`, {
        animation: 'fade',
        arrow: true,
        content: title,
        theme: 'gradient', // Customize the theme in your CSS if needed
        placement: 'top'
      });
    },
    saveTemplate() {
      this.emailTemplates[this.selectedTemplate - 1] = this.updatedHtml;
      this.selectedTemplate = null
    },
    updateHtml(event) {
      console.log('event', event.target.innerHTML);
      this.updatedHtml = event.target.innerHTML
    },
    getProgress(row) {
      const { steps } = row;
      let text = 'Steps Not Initiated';
      if(steps) {
        if(steps[2].isChecked){
          text = 'Final Step Completed: Text Message Sent'
        } else if(steps[1].isChecked){
          text = 'Step 2 Completed: Second Email Sent'
        } else if(steps[0].isChecked){
          text = 'Step 1 Completed: First Email Sent'
        }
      }
      return text
    },
    refreshData() {
      this.selectedUser = null
      this.emailTemplates = []
      this.updatedHtml = ''
      this.selectedTemplate = null
      this.hideTemplates = false
      this.renderDatatable()
      // this.getTrafficData();
    },
    formatDate(date) {
      return moment(date).tz('America/New_York').format('MMM DD YYYY, hh:mm a');
    },
    formattedBashResponse(log) {
      try {
        if(!log) return ''
        // Extract JSON part from the log message
        const jsonPart = log.split("JSON:")[1];
        console.log('jsonPart', jsonPart);
        return JSON.stringify(JSON.parse(jsonPart), null, 1);
      } catch (error) {
        return "Invalid JSON format";
      }
    },
    viewDetails(data){
      this.selectedUser = data
      this.overTrafficAlertSteps = []
      if(this.selectedUser.steps && this.selectedUser.steps.length > 0){
        this.overTrafficAlertSteps = this.selectedUser.steps;
      } else {
        this.overTrafficAlertSteps = this.originalSteps
      }
    },
    async viewEmailTemplates() {
      try {
        this.emailTemplateLoading = true
        if(this.emailTemplates.length > 0){
          this.hideTemplates = true
          this.emailTemplateLoading = false;
          return true
        }
        const response = await this.$http.post('/traffic/preview-email', {
          grant_type: 'token',
          message: '',
          subject: '',
          trafficData: {
            "goodBots": this.selectedUser.totalGoodBots,
            "badBots": this.selectedUser.totalBadBots,
            "maliciousBots": this.selectedUser.totalMaliciousBots,
            "uniqueVisits": this.selectedUser.billable,
            "total": this.selectedUser.totalVisitors
          },
          name: this.selectedUser.name,
          emailTo: 'sara@bigscoots.com'
        });
        console.log('response', response.data);
        if(response.data.success){
          this.emailTemplates = response.data.templates || [];
          this.hideTemplates  = true;
        }
      } catch (e) {
        console.log('error', e);
        this.showToast({message: 'Something went wrong while previewing email templates!' , duration: 2000}, true, 'danger')
      } finally {
        this.emailTemplateLoading = false
      }
    },
    async syncTrafficData() {
      try {
        this.syncLoading = true
        const response = await this.$http.post('/hostingAccounts/sync-over-limit-traffic', {
          grant_type: 'token',
          firstName : this.user.firstName,
          lastName : this.user.lastName,
        });
        console.log(`response from api ${response.data}`)
        swal('Success', response.data.message, 'success')
      } catch (e) {
        swal('Error', 'Something went wrong while synchronizing traffic data!', 'error')
      }
      this.syncLoading = false
    },
    formatNumber (n) {
      if (n < 1e3) { return n }
      if (n >= 1e3 && n < 1e6) { return +(n / 1e3).toFixed(1) + 'K' }
      if (n >= 1e6 && n < 1e9) { return +(n / 1e6).toFixed(1) + 'M' }
      if (n >= 1e9 && n < 1e12) { return +(n / 1e9).toFixed(1) + 'B' }
      if (n >= 1e12) { return +(n / 1e12).toFixed(1) + 'T' }
    },
    convertToK(num = 0) {
      const a = Number(num)
      if (a >= 1000) {
        return (a / 1000).toFixed(0) + 'K';
      }
      return a.toString();  // Return the number as-is if less than 1000
    },
    renderDatatable() {
      console.log('rendering', $.fn.DataTable.isDataTable(`#visitors-table`))
      if($.fn.DataTable.isDataTable('#visitors-table')) {
        $(`#visitors-table`).DataTable().destroy();
      }
      setTimeout(function () {
        $.fn.dataTable.ext.type.order["traffic-size-pre"] = function (data) {
          if (data.endsWith("T")) {
            return parseFloat(data) * 1000000000000; // Convert "T" to numeric
          }else if (data.endsWith("B")) {
            return parseFloat(data) * 1000000000; // Convert "B" to numeric
          }else if (data.endsWith("M")) {
            return parseFloat(data) * 1000000; // Convert "M" to numeric
          } else if (data.endsWith("K")) {
            return parseFloat(data) * 1000; // Convert "K" to numeric
          }
          return parseFloat(data) || 0; // Default to number or 0
        };
        $.fn.dataTable.ext.type.order["percentage-pre"] = function (data) {
          return parseFloat(data.replace("%", "")) || 0; // Remove '%' and convert to number
        };
        $(`#visitors-table`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo" : false,
          "ordering": true,
          "columnDefs": [
            {targets: [8], width: '10%' },
            { targets: [2,3], type: "traffic-size" },
            { targets: [5], type: "percentage" },
            { "orderable": false, "targets": [ 6, 7, 8] } // Disable sorting on the first and third columns
          ]
        });
      }, 0)
    },
    goToPage(pageNum) {
      this.pageNumber = pageNum-1;
    },
    getMonthName (number) {
      const month = this.monthArray.find(m => Number(m.key) === Number(number))
      return month.value
    },
    async getPresetReplies(){
      this.presetMacros=[]
      let result=await db.collection("permissions")
          .doc("preset_macros_traffic")
          .get();
      if(result.exists){
        this.presetMacros = result.data().replies;
      }
      let overtrafficAlerts=await db.collection("permissions")
          .doc("overTrafficAlertSteps")
          .get();
      if(overtrafficAlerts.exists){
        this.originalSteps = overtrafficAlerts.data().checklist;
      }
    },
    openTicketModal(row){
      this.$refs.trafficTicketModal.load(this.presetMacros, row)
    },
    createGroups () {
      this.pageNumber = 0
      const filteredTrafficRecords = this.traffic.filter(t => t.name.toLowerCase().includes(this.search.toLowerCase()) || t.email.toLowerCase().includes(this.search.toLowerCase()))
      const array = []
      filteredTrafficRecords.forEach(tData => {
        const alreadyExist = array.find(g => g.uid === tData.uid)
        if (alreadyExist) {
          alreadyExist.records.push(tData)
          if (alreadyExist.max && Number(alreadyExist.max.currentVisitors) < Number(tData.currentVisitors)) {
            alreadyExist.max = tData
          }
        } else {
          array.push({
            uid: tData.uid,
            email: tData.email,
            name: tData.name,
            show: false,
            max: tData,
            records: [tData]
          })
        }
      })
      // this.groups = filteredTrafficRecords;
    },
    async getTrafficData(){
      this.gettingData = true
      try {
        const data = []
        this.traffic = []
        const month = new Date().getMonth() + 1
        const year = new Date().getFullYear()
        this.listener = await db.collection('overTrafficBilling')
            .where('snoozedDate', '<', new Date().toISOString())
            .where('status', 'in', ['pending', 'running', 'snoozed'])
            .where('month', '==', month)
            .where('year', '==', year).onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(changeDoc => {
            if (changeDoc.type === 'added'){
              this.traffic.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
            }
            if(changeDoc.type === 'modified') {
              console.log('modified')
              const data = {id: changeDoc.doc.id, ...changeDoc.doc.data()}
              let taskToUpdate = this.traffic.find((task) => task.id === data.id );
              const allKeys = Object.keys(data);
              for (const key of allKeys){
                taskToUpdate[key] = data[key];
              }
            }
            if(changeDoc.type === 'removed') {
              this.traffic = this.traffic.filter(el => el.id !== changeDoc.doc.id)
            }
          });
        });
        const lastUpdated = await db.collection('overTrafficBilling').doc('last_updated_date_for_all_accounts').get();
        if(lastUpdated.exists) {
          this.last_updated = lastUpdated.data().last_updated
          this.last_updated = moment(String(this.last_updated)).format('DD MMM, YYYY hh:mm A')
        }
        await this.renderDatatable()
      } catch (e) {
        console.log('Error in getting traffic data', e.toString())
      }
      this.gettingData = false
    },
    getPercentage(data){
      console.log(data)
      if (Number(data.billable) > Number(data.totalVisitors)) {
        return (((Number(data.billable))/Number(data.totalVisitors))*100).toFixed(2)
      }
      return 0
    },
    initDataTable(){
      $(`#visitors-table`).DataTable({
        pagingType: "full_numbers",
        lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
        destroy: true,
        retrieve: true,
        deferRender: true,
        "ordering": true,
        stateSave: true,
        'columnDefs': [ {
          'targets': [6,7, 8], /* column index */
          'orderable': false, /* true or false */
        }],
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search Traffic",
          size: 50
        }
      });
    },
    openTicket(row){
      if(row.ticket){
        window.open(row.ticket)
      }
    },
    resolve(row){
      swal({
        title: 'Are you sure?',
        text: 'Are you sure to resolve this?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: "#6ACF98",
        cancelButtonColor: "#EE8057"
      }).then((result) => {
        if(result.value) {
          this.loading = true;
          db.collection('trafficBillings').doc(row.id).delete().then(() => {
            swal('Success!', 'You have successfully resolved!', 'success');
            this.getTrafficData();
          });
        }
      })
    },
    async removeFromDb(row) {
      if (!row || !row.id) return;
      const result = await swal({
        title: 'Are you sure?',
        text: `This will permanently remove the traffic record for "${row.primaryDomain || row.email || row.id}" from the database.`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it',
        confirmButtonColor: '#EE8057',
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#6ACF98'
      });
      if (!result || !result.value) return;
      try {
        this.removingId = row.id;
        await db.collection('overTrafficBilling').doc(row.id).delete();
        this.traffic = this.traffic.filter(t => t.id !== row.id);
        swal({
          title: 'Deleted!',
          text: 'Traffic record has been removed from the database.',
          type: 'success'
        });
      } catch (e) {
        console.log('Error removing traffic record', e.toString());
        swal({
          title: 'Error!',
          text: `Something went wrong while removing the record: ${e.toString()}`,
          type: 'error'
        });
      } finally {
        this.removingId = null;
      }
    },
    async loginAsUser(data){
      this.loading=true
      const userRef=await db.collection('users').where('email', '==', data.email).limit(1).get()
      let user=null
      if(userRef.size>0){
        userRef.forEach(el => {
          user= {id: el.id, ...el.data()}
        })
        window.open(`https://wpo.bigscoots.com/user/dashboard?id=${user.id}`,'WPO-Bigscoots');
      }else{
        swal('Error!', 'User not found!', 'error');
      }
      this.loading=false
    },
    async openModal(data, from){
      this.selectedRow= data
      if(from === 'ticket') {
        $('#addTicketModal').modal('show');
      } else {
        const ref = await db.collection('trafficOverageEmailHistory').where('email', '==', data.email).get();
        if(ref.size) {
          const {history} = ref.docs[0].data();
          data.history = history
        }
        this.$emit('loadEmailModal', data)
      }
    },
    async addTicket(){
      try{
        this.loading=true
        await db.collection('overTrafficBilling').doc(this.selectedRow.id).update({ticket: this.selectedRow.ticket})
        swal({
          title: "Success!",
          text: "You have successfully added ticket!",
          type: "success"
        })
        $('#addTicketModal').modal('hide');
        this.loading=false
      }
      catch (e){
        this.loading=false
        this.selectedRow=null
        swal({
          title: "Error!",
          text:
              "Something went wrong while adding ticket!",
          type: "error",
          confirmButtonText: "Try Again",
          confirmButtonColor: "#EE8057"
        })
      }
    },
    async selectSnoozeValue(data, e){
      try {
        let date= new Date()
        let val= e.target.value
        if(val === '1 day'){
          date.setDate(date.getDate() + 1)
        }
        else if(val === '1 week') {
          date.setDate(date.getDate() + 7)
        }else if(val === '1 month') {
          date.setMonth(date.getMonth() + 1)
        }else if(val === '3 months') {
          date.setMonth(date.getMonth() + 3)
        }
        let status = val === 'reset' ? 'pending' : 'snoozed'
        console.log(date)
        await db.collection('overTrafficBilling').doc(data.id).update({snoozeVal: val === 'reset' ? '' : val, snoozedDate: date.toISOString(), status})
        await this.getTrafficData()
        swal({
          title: "Success!",
          text: "You have successfully snoozed the selected record!",
          type: "success"
        })
      }
      catch (e) {
        swal({
          title: "Error!",
          text: `Something went wrong while snoozing! ${e.toString()}`,
          type: "error",
          confirmButtonText: "Try Again",
          confirmButtonColor: "#EE8057"
        })
      }
    }
  },

}
</script>

<style scoped>
th{
  height: 30px;
}
.details-control {
  background: url('../../../assets/img/details_open.png') no-repeat center center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: block;
  margin: 13px auto;
}

.details-control.shown {
  background: url('../../../assets/img/details_close.png') no-repeat center center;
}
tr > th,td{
  padding: 4px 7px !important;
  text-align: center!important;
}
tr > th{
  font-size: 12px !important;
  font-weight: 400 !important;
}
.pagination{
  display: inline-flex !important;
}
.light{
  background-color: #f2f2f2 !important;
}
#disabled-btn:hover:after {
  position: absolute;
  top: 0;
  left: 75%;
  width: 100%;
  content: attr(title);
  background-color: #ffa;
  color: #000;
  line-height: 1.4em;
  border: 1px solid #000;
}
.step {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

</style>
